import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/imgs/transh.svg'


const _withScopeId = n => (_pushScopeId("data-v-749294bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screening" }
const _hoisted_2 = { class: "screeing-filter" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "screening-text" }, "筛选条件：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 清空 ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Tag, {
        filterCondition: $props.filterCondition,
        onHandleCloseTag: $setup.handleCloseTag
      }, null, 8, ["filterCondition", "onHandleCloseTag"])
    ]),
    _createElementVNode("div", {
      class: "clear",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleClear && $setup.handleClear(...args)))
    }, _hoisted_6)
  ], 512)), [
    [_vShow, $props.filterCondition.length]
  ])
}